document.addEventListener('DOMContentLoaded', () => { 

  const frTodos = () => {
    document.querySelectorAll('[data-frbg]').forEach(frbgElement => {
      const bgSet = frbgElement.getAttribute('data-frbgset');
      if(bgSet) {
        frbgElement.setAttribute('data-bgset', bgSet);
        frbgElement.removeAttribute('data-frbgset');
      }
      const bgSrc = frbgElement.getAttribute('data-frbg');
      if(bgSrc) {
        frbgElement.style.backgroundImage = `url(${bgSrc})`;
      }
    });
    document.querySelectorAll('[data-frtext]').forEach(frTextElement => {
      frTextElement.innerHTML = frTextElement.getAttribute('data-frtext');
    });
    // minicart workaround
    /* edo888 removed
    document.querySelectorAll('.minicart__label').forEach(miniCartLabel => {
      miniCartLabel.style.display = 'none';
      const cartAnchor = document.createElement('a');
      cartAnchor.setAttribute('href', '/cart');
      cartAnchor.setAttribute('class', 'minicart__label');
      cartAnchor.innerHTML = miniCartLabel.innerHTML;
      miniCartLabel.parentNode.insertBefore(cartAnchor, miniCartLabel.nextSibling);
    });
    */
    const $pdpAtcButton = document.querySelector('.button--addToCart[data-original-text]');
    if($pdpAtcButton) {
      $pdpAtcButton.setAttribute('data-original-text', 'Ajouter au panier');
    }
    _bstrLocale.buttons.adding = 'Ajouter...';
    _bstrLocale.buttons.sold_out = 'Épuisé';
  };

  if(window.location.href.indexOf('fr.kidobebe.com') > -1) {
    document.body.setAttribute('data-lang', 'fr');
    frTodos();
  }

  const $footerFaqAnchor = document.querySelector('#shopify-section-footer a[href="/pages/faqs"]');
  if($footerFaqAnchor !== null) {
    const $disclaimerParagraph = document.createElement('p');
    $disclaimerParagraph.classList.add('footer__disclaimer-text');
    $disclaimerParagraph.innerHTML =
      document.body.getAttribute('data-lang') == 'fr'
      ? '** Certaines conditions et exclusions s\'appliquent. Cette promotion ne peut être combinée avec aucun autre coupon.'
      : '** Conditions and exclusions apply. This promotion cannot be combined with any other coupon.';
    $footerFaqAnchor.parentElement.appendChild($disclaimerParagraph);
  }

  document.body.addEventListener('click', event => {
    const refTarget = event.target;
    const refTargetAttr = refTarget.getAttribute('data-navigateto');
    const closestTarget = refTarget.closest('[data-navigateto]');
    let navToTarget = null;
    if(refTargetAttr) {
      navToTarget = refTarget;
    }
    if(closestTarget) {
      navToTarget = closestTarget;
    }
    if(navToTarget) {
      const navToUrl = navToTarget.getAttribute('data-navigateto');
      if(navToUrl) {
        event.preventDefault();
        window.location = navToUrl;
      }
    }
  });

  document.querySelectorAll('[data-jump]').forEach(jumpHandle => {
    jumpHandle.addEventListener('click', event => {
      const $target = event.target;
      const letter = $target.getAttribute('data-jump');
      if(letter) {
        const $targetWrapper = document.querySelector(`.list__brand-title-${letter}`);
        $targetWrapper.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    });
  });
  
  document.querySelectorAll('.carousel-of-cards').forEach((carouselOfCards) => {
    let flkty = new Flickity(carouselOfCards, {
      cellAlign: 'left',
      cellSelector: '.card--holder',
      contain: true,
      prevNextButtons: true,
      pageDots: false
    });
  });

  /*const $prodImgCarousel = document.querySelector('.product__img-carousel');
  const prodImgCarouselFlkty = new Flickity($prodImgCarousel, {
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: true,
    selectedAttraction: 0.2,
    friction: 0.8,
    on: {
      change: index => {
        const $activeSlide = $prodImgCarousel.querySelector(`[dataimgindex="${index + 1}"]`);
        if(!!$activeSlide) {
          let activeSlideForVariantOption = $activeSlide.getAttribute('data-imgforvariants');
          if(!!activeSlideForVariantOption) {
            activeSlideForVariantOption = activeSlideForVariantOption.split('|').filter(item => !!item);
            const $optionSelectbox = document.querySelector('form .product__swatches select');
            if(!!$optionSelectbox
            && !!activeSlideForVariantOption[0]) {
              const $optionSelectboxRelatedOption = $optionSelectbox.querySelector(`option[value="${activeSlideForVariantOption[0]}"]`);
              $optionSelectbox.value = $optionSelectboxRelatedOption.getAttribute('value');
              $optionSelectbox.dispatchEvent(new CustomEvent('change'));
            }
          }
        }
      }
    }
  });
  
  const $prodThumbsCarousel = document.querySelector('.product__thumbs-carousel');
  const prodThumbsCarouselFlkty = new Flickity($prodThumbsCarousel, {
    asNavFor: '.product__img-carousel',
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: true
  });*/
  
  /********** ashutosh - new carousel Initialization (Thubms in center-bottom) ****
  const $carouselMain = document.querySelector('.carousel-main');
  const carouselMainFlkty = new Flickity($carouselMain);	
  /********** ashutosh - new carousel Initialization - END ****/

  /********** Satyendra - new carousel Initialization (Thubms in left) ****/
     /*  this custom script moved to "assets/slick-product-slider-scripts.js"  	 */
  /********** END Satyendra - new carousel Initialization (Thubms in left) ****/
  
  /****************** Script when we use "Color Swatch" or "Image Swatch" for selecting colors *******************/
	
    const pdpFormATCVariantFields = document.querySelectorAll('body.template--product .product__swatches span');
    if(!!pdpFormATCVariantFields) {
      pdpFormATCVariantFields.forEach(pdpFormATCVariantField => {
        pdpFormATCVariantField.onclick = (event) => {
          const $target = event.target;

          const $form = $target.closest('form');
          const $atcVariantIdField = $form.querySelector('[name="id"]');
          const $variantsJsonElement = $form.querySelector('noscript[data-bstr-swatch]');
          let variantsJson = false;
          try { variantsJson = JSON.parse($variantsJsonElement.innerHTML); } catch(err) {};
          setTimeout(() => {
            const newCustomEvent = new CustomEvent('prodVariant:changed', {
              detail: {
                newOptionValue: $target.dataset.swatchOption,
                newVariantId: $atcVariantIdField.value,
                newVariant: !!variantsJson && !!variantsJson[$atcVariantIdField.value*1] ? variantsJson[$atcVariantIdField.value*1] : false
              }
            });
            $form.dispatchEvent(newCustomEvent);
            //console.log(newCustomEvent);
          }, 50);
        };
      });
    }
    if(jQuery('form').find('.product__swatches span').length){ /* Fixed by Ashutosh - without this check scrits shows error on those product where SWATCHES are not enabled*/
      document.querySelector('form .product__swatches span').dispatchEvent(new CustomEvent('click'));
    }
    
  /****************** Script when we use "Color Swatch" or "Image Swatch" for selecting colors - END *******************/
  
  /****************** Script when we use "Dropdown" for selecting colors *******************/	
    /*const pdpFormATCVariantFields = document.querySelectorAll('body.template--product .product__swatches select');
    if(!!pdpFormATCVariantFields) {
      pdpFormATCVariantFields.forEach(pdpFormATCVariantField => {
        pdpFormATCVariantField.onchange = (event) => {
          const $target = event.target;
          const $form = $target.closest('form');
          const $atcVariantIdField = $form.querySelector('[name="id"]');
          const $variantsJsonElement = $form.querySelector('noscript[data-bstr-swatch]');
          let variantsJson = false;
          try { variantsJson = JSON.parse($variantsJsonElement.innerHTML); } catch(err) {};
          setTimeout(() => {
            const newCustomEvent = new CustomEvent('prodVariant:changed', {
              detail: {
                newOptionValue: $target.value,
                newVariantId: $atcVariantIdField.value,
                newVariant: !!variantsJson && !!variantsJson[$atcVariantIdField.value*1] ? variantsJson[$atcVariantIdField.value*1] : false
              }
            });
            $form.dispatchEvent(newCustomEvent);
          }, 50);
        };
      });
    }
    document.querySelector('form .product__swatches select').dispatchEvent(new CustomEvent('change'));*/

  /****************** Script when we use "Dropdown" for selecting colors - END *******************/

  const pfpForms = document.querySelectorAll('.shopify-product-form');
  if(!!pfpForms) {
    pfpForms.forEach(pfpForm => {
      pfpForm.addEventListener('prodVariant:changed', event => {
        if(!!event.detail.newVariant) {
          if(!!event.detail.newVariant.sku) {
            if(jQuery('form').find('.product__spec.spec-name--sku .spec__data').length){
              document.querySelector('.product__spec.spec-name--sku .spec__data').innerHTML = event.detail.newVariant.sku;
            }
            if(jQuery('form').find('.product__spec.spec-name--barcode .spec__data').length){
              document.querySelector('.product__spec.spec-name--barcode .spec__data').innerHTML = event.detail.newVariant.barcode;
            }
            
            //document.querySelector('.top-sku-wrapper .sku-text').innerHTML = event.detail.newVariant.sku;
			//console.log(event.detail);	
          }
          /* Availablity status update when swatch changes */
          if(event.detail.newVariant.qty<=0 && event.detail.newVariant.inventory_management) {
            jQuery('.product__spec.spec-name--availability.in-store-status').addClass("outofstock");
            document.querySelector('.product__spec.spec-name--availability.in-store-status .spec__data').innerHTML = document.body.getAttribute('data-lang') == 'fr' ? 'Commande spéciale' : 'Special order';
          }else if(event.detail.newVariant.qty>0 && event.detail.newVariant.qty<=2 && event.detail.newVariant.inventory_management){
          	jQuery('.product__spec.spec-name--availability.in-store-status').removeClass("outofstock");
            document.querySelector('.product__spec.spec-name--availability.in-store-status .spec__data').innerHTML = document.body.getAttribute('data-lang') == 'fr' ? 'Il ne reste que quelques-uns' : 'Only a few left';
          }else{
          	jQuery('.product__spec.spec-name--availability.in-store-status').removeClass("outofstock");
            document.querySelector('.product__spec.spec-name--availability.in-store-status .spec__data').innerHTML = document.body.getAttribute('data-lang') == 'fr' ? 'Disponible' : 'Available';
          }
          /* END - Availablity status update when swatch changes */
          
          /*if(!!event.detail.newVariant.options) {
            const $sliderImgForVariant = document.querySelector(`.product__img-carousel-item[data-imgforvariants*="${event.detail.newVariant.options.join('#')}"]`);
            if(!!$sliderImgForVariant) {
              const sliderImgForVariantIndex = [...$sliderImgForVariant.parentElement.children].indexOf($sliderImgForVariant);console.log($sliderImgForVariant);
              prodImgCarouselFlkty.select(sliderImgForVariantIndex);
              prodImgCarouselFlkty.focus();
            }
          }*/
          
          /********** ashutosh - new carousel (thubs are in center-bottom) - Focus slider image on Swatch change  ***
          if(!!event.detail.newVariant.options) {
            const $sliderImgForVariant = document.querySelector(`.img-carousel-item[data-imgforvariants*="${event.detail.newVariant.options.join('#')}"]`);
            if(!!$sliderImgForVariant) {
              const sliderImgForVariantIndex = [...$sliderImgForVariant.parentElement.children].indexOf($sliderImgForVariant);console.log($sliderImgForVariant);
              carouselMainFlkty.select(sliderImgForVariantIndex);
              carouselMainFlkty.focus();
              
            }
          }
          /********** ashutosh - new carousel - Focus slider image on Swatch change - END ****/
         
          /********** Satyendra - new carousel (thubs are in Left) - Focus slider image on Swatch change  ****/
          /*if(!!event.detail.newVariant.options) {
            const $sliderImgForVariant = document.querySelector(`.img-carousel-item[data-imgforvariants*="${event.detail.newVariant.options.join('#')}"]`);
            if(!!$sliderImgForVariant) {
              const sliderImgForVariantIndex = $sliderImgForVariant.dataset.imgindex;
              console.log($sliderImgForVariant);
              jQuery('.slider-nav').slick('slickGoTo', sliderImgForVariantIndex-1);
            }
          }*/
          /********** Satyendra - new carousel - Focus slider image on Swatch change - END ****/
          
        }
      });
    });
  }

  let pdpThumbsCarousel = document.querySelector('.gallery__horiz-thumb-Carousel > .gallery__thumbnails');
  if(pdpThumbsCarousel != null) {
    let flkty = new Flickity(pdpThumbsCarousel, {
      cellAlign: 'left',
      cellSelector: '.gallery__thumbnail',
      contain: true,
      prevNextButtons: true,
      pageDots: false
    });
  }

  document.querySelectorAll('.filter__group .filter__show-more, .filter__group .filter__show-less').forEach((filterShowMoreBtn) => {
    filterShowMoreBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const filterGroup = event.target.closest('.filter__group');
      if(filterGroup.classList.contains('show-more-items')) {
        filterGroup.classList.remove('show-more-items');
      } else {
        filterGroup.classList.add('show-more-items');
      }
    });
  });

  document.querySelectorAll('.filter__group.display-on-filters-bar').forEach(filterToDisplayOnFiltersBar => {
    const filterTitle = filterToDisplayOnFiltersBar.querySelector('.filter__group-title').childNodes[0].textContent;
    const newFilterDropdownWrapper = document.createElement('div');
    newFilterDropdownWrapper.classList.add('filter__dropdown');
    newFilterDropdownWrapper.innerHTML = '<i class="filter__icon uil uil-angle-down"></i>';
    const newFilterDropdown = document.createElement('select');
    newFilterDropdown.classList.add('filter-dropdown');
    newFilterDropdown.innerHTML = `<option value="${window.kb.collectionUrl}">Any ${filterTitle}</option>`;
    newFilterDropdownWrapper.append(newFilterDropdown);

    filterToDisplayOnFiltersBar.querySelectorAll('.filter__tag').forEach(filterTag => {
      const dropdownOption = document.createElement('option');
      const href = filterTag.getAttribute('href') || window.location.href;
      dropdownOption.setAttribute('value', href);
      dropdownOption.innerHTML = filterTag.innerHTML;
      if(filterTag.innerHTML.indexOf('Reset') > -1) {
        return;
      }
      if(window.location.href.indexOf(href) > -1) {
        dropdownOption.setAttribute('selected', 'selected');
      }
      newFilterDropdown.append(dropdownOption);
    });
    
    const filterBar = document.querySelector('.filter__bar');
    const filterViews = filterBar.querySelector('.filter__views');
    if(filterViews !== null) {
      filterViews.parentNode.insertBefore(newFilterDropdownWrapper, filterViews.nextSibling);
      filterToDisplayOnFiltersBar.style.display = 'none';
    }
  });

  document.querySelectorAll('select.filter-dropdown').forEach(filterDropdown => {
    filterDropdown.addEventListener('change', (event) => {
      const dropdown = event.target;
      window.location = dropdown.value;
    });
  });

  

});

window.addEventListener('load', () => {

  setTimeout(() => {
    let frequentlyBoughtContainer = document.querySelector('body > .cbb-frequently-bought-container'),
        productDetails = document.querySelector('main > .shopify-section__product-details');
    if(productDetails != null
    && frequentlyBoughtContainer != null) {
      productDetails.parentNode.insertBefore(frequentlyBoughtContainer, productDetails.nextSibling);
    }
  }, 5 * 1000);

  $('body').on('click', (event) => {
    const $target = $(event.target);
    if($('#paybright-learnmore').length > 0) {
      if($target.is('#paybright-learnmore')) {
        $('body').addClass('pb-modal-open');
      }
      if($target.is('#pbModal')) {
        $('body').removeClass('pb-modal-open');
      }
    }
  });

});

jQuery(document).ready(function(){
	/****** Adding Color Swatch count number if exceed from 5 - Similar Product Section *******/
  	jQuery('.color-swatches-similar-product .swatches__holder ').each(function(){
        var span_count=jQuery(this).find('span.swatch--color').length;
        if(span_count>5){
            var extra=parseInt(span_count)-5;
            jQuery(this).append('<span class="similar-product-hidden-count">+'+ extra + '</span>');
        }
    });
  
  jQuery( window ).on("load", function() {
     //jQuery('.banner-slider').css('visibility','visible');
     jQuery('body').addClass('pageLoded');
  });

  /****** Change image as per color variant select in SIMILAR PRODUCT SECTION *******/
  jQuery('.similar_pro_variants').on("click", function(){
      var data_src=jQuery(this).data("variantFimg");
      jQuery(this).parents('.card--default').find('.card__img img').replaceWith('<img src="'+data_src+'" >');

  });

  /****** Change image as per  variant select in FREQUENTLY BOUGHT TOGETHER section *******/
  jQuery('.inline-upsell__product select').on("change", function(){
      var data_src=$(this).find(':selected').data("variantFimg");
      jQuery(this).parents('.inline-upsell__product').find('.card--default .card__img img').replaceWith('<img src="'+data_src+'" >');
      console.log(data_src)
  });
  	
  jQuery('.button-back-to-top').on('click', function(){
    jQuery('html,body').animate({scrollTop:0},250);
  });

  let isp_is_mobile = false;
  /*********** Sticky Mobile Menu bar when scroll down ****************/
  jQuery(window).bind('scroll', function() {
      if (jQuery(window).scrollTop() > 150) {
          jQuery('.page__header--mobile').addClass('fixed-menu');
        	jQuery('.back-btn-wrapper').addClass('active');
            if(isp_is_mobile){
                jQuery('.button-at-bottom.category-filter').removeClass('hide');
            }
      }else {
          jQuery('.page__header--mobile').removeClass('fixed-menu');
        jQuery('.back-btn-wrapper').removeClass('active');
        if(isp_is_mobile){
          jQuery('.button-at-bottom.category-filter').addClass('hide');
        }
      }
  });

$( "body.page--find .giftreggie-header p" ).replaceWith( "<p>Access your loved one's registry to choose the perfect gift for their little ones!</p>" );

$(".footer__block .footer__links>.footer__title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".footerLinksContent")
        .slideUp(200);
      $(".footer__block .footer__links>.footer__title i")
        .removeClass("uil-minus")
        .addClass("uil-plus");
    } else {
      $(".footer__block .footer__links>.footer__title i")
        .removeClass("uil-minus")
        .addClass("uil-plus");
      $(this)
        .find("i")
        .removeClass("uil-plus")
        .addClass("uil-minus");
      $(".footer__block .footer__links>.footer__title").removeClass("active");
      $(this).addClass("active");
      $(".footerLinksContent").slideUp(200);
      $(this)
        .siblings(".footerLinksContent")
        .slideDown(200);
    }
  });
  
  /************** Product Detail Page - Move Product Description Accordian to outer cell ***********/
  jQuery(".col-12.accordion.product__accordion").insertAfter(".row.product__row.max-width.product__row--default");
  jQuery(".col-12.accordion.product__accordion").not('.meta-accordian').show();
  jQuery('.read-more-less').on("click", function(){
    jQuery('.meta-accordian').toggle(); 
    if(jQuery(this).text()=="Read More"){
      jQuery(this).text("Read Less");
    }else{
      jQuery(this).text("Read More");
    }
  });

  /***************** Remove Coming Soon Classes if expiry date is passed (INcomplete Code) ***********
  if(jQuery('.product__row ').hasClass("special-classes__coming-soon")){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today =  yyyy+'-'+ mm+'-'+dd;
      console.log(today);
      if(today < jQuery('.product__row ').data("expirydate")){
          jQuery('.product__row ').removeClass("special-classes__coming-soon");
      }
      
  }
  ************************************************************************************************/
  /***************************Account popup scripts - ASHU - 28Aug [START]****************************/
  jQuery('.user_modal_close').on("click", function(){
      jQuery('[data-userbtn-input]').prop("checked", false);
  
  });
  jQuery('.user__button-mobile').on("click", "label.overlay", function(){
      jQuery('[data-userbtn-input]').prop("checked", false);
   });
  jQuery('.user__button-mobile label').on("click", function(){
      jQuery('[data-userbtn-input]').prop("checked", true);
  
  });
  /***************************Account popup scripts - ASHU - 28Aug [END]****************************/

  /***************************Force stop scrolling for body when open Mobile menu in MOBILE DEVICE [START]****************************/
  console.log(window.innerWidth);
  if(window.innerWidth <= 425){
    jQuery(".mobile-submenu-label").on("click", function(){
      jQuery('body').addClass("lock-scroll");
    });
    jQuery("label.overlay--nav").on("click", function(){
      jQuery('body').removeClass("lock-scroll");
    });
  }
  
  
  /***************************Force stop scrolling for body when open Mobile menu in MOBILE DEVICE [END]****************************/


  jQuery("h2.inline-upsell__heading").each(function(index, element) {
    var heading = jQuery(element), word_array, last_part, first_word; 
    word_array = heading.html().split(/\s+/);
    first_word = word_array.shift();         
    last_part = word_array.join(' ');        
    heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
});

  var words0 = jQuery(".create_giftregistry_mob h3").text().split(' ');
jQuery(".create_giftregistry_mob h3").html("<strong>"+words0.slice(0, 2).join(' ') + "</strong>" + " " + words0.slice(2, words0.length).join(' ') + "");
  
  var words1 = jQuery(".giftreggie-front .giftreggie-header h3").text().split(' ');
jQuery(".giftreggie-front .giftreggie-header h3").html("<strong>"+words1.slice(0, 2).join(' ') + "</strong>" + " " + words1.slice(2, words1.length).join(' ') + "");

var words2 = jQuery("#s--product-page__similar-products h2.font__family--title").text().split(' ');
jQuery("#s--product-page__similar-products h2.font__family--title").html(words2.slice(0, words2.length - 2).join(' ') + " " + "<strong>" + words2.slice(words2.length - 2, words2.length).join(' ') + "</strong>");
  




  jQuery(".jdgm-rev-widg__header .jdgm-rev-widg__title").each(function(index, element) {
		var heading = jQuery(element), word_array, last_part, first_word; 
		word_array = heading.html().split(/\s+/);
		first_word = word_array.shift();         
		last_part = word_array.join(' ');        
		heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
	});
	setTimeout(function(){
        jQuery(".jdgm-rev-widg__header .jdgm-rev-widg__title").each(function(index, element) {
    		var heading = jQuery(element), word_array, last_part, first_word; 
    		word_array = heading.html().split(/\s+/);
    		first_word = word_array.shift();         
    		last_part = word_array.join(' ');        
    		heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
    	});
    }, 2000);
    setTimeout(function(){
        jQuery(".jdgm-rev-widg__header .jdgm-rev-widg__title").each(function(index, element) {
    		var heading = jQuery(element), word_array, last_part, first_word; 
    		word_array = heading.html().split(/\s+/);
    		first_word = word_array.shift();         
    		last_part = word_array.join(' ');        
    		heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
    	});
    }, 5000);

    /******* Frequently bought together - add count in add to cart button ************************/
     setTimeout(function(){
          var product_count= jQuery('.inline-upsell__toggle:checked+.inline-upsell__product').length;
          jQuery(".inline-upsell__atc button").text("Add "+product_count+" to the Cart");
      }, 300);
    jQuery('.inline-upsell__product').on("click", function(){
      setTimeout(function(){
          var product_count= jQuery('.inline-upsell__toggle:checked+.inline-upsell__product').length;
          if(product_count==0){
            jQuery(".inline-upsell__atc button").attr("disabled", true);
            jQuery(".inline-upsell__atc button").text("Add to the Cart");
          }else{
            jQuery(".inline-upsell__atc button").attr("disabled", false);
            jQuery(".inline-upsell__atc button").text("Add "+product_count+" to the Cart");
          }
          
      }, 300);
    });

  /********* custom captcha on login form **************/
  jQuery('.login-page form').first().ebcaptcha();
  jQuery('.login-popup form').first().ebcaptcha();
  jQuery('#create_customer').ebcaptcha();

  jQuery('.button--notice').on("click", function(){
      jQuery('.recover__password').toggle();
  });

  /********* Searchbar - HIT ENTER to search keyword **************/
  jQuery(function() {
    jQuery('.search__container form').each(function() {
      jQuery(this).find('input').keypress(function(e) {
          // Enter pressed?
          if(e.which == 10 || e.which == 13) {
              this.form.submit();
          }
      });
    });
    
    
  });
  jQuery('.gl-d-searchbox').each(function() {
      jQuery(this).find('input').keypress(function(e) {
          // Enter pressed?
          if(e.which == 10 || e.which == 13) {
              this.form.submit();
          }
      });
    });
  setTimeout(function(){
    jQuery('.gl-d-searchbox').each(function() {
      jQuery(this).find('input').keypress(function(e) {
          // Enter pressed?
          if(e.which == 10 || e.which == 13) {
              this.form.submit();
          }
      });
    });
  }, 10000);

  
});

/********** Product Decscription Video Iframe script in Quick Shop Popup on collection pages *******************/
jQuery(document).ready(function(){
  jQuery('.template--collection').on("click", "#gfqv-modal .youtube-placeholder",function(){
    const videoId = jQuery(this).data('videoId');
    const iframe = document.createElement('iframe');
    //alert(videoId);
    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&rel=0&modestbranding=1`);
    iframe.setAttribute('title', 'YouTube video player');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.style.position = 'relative';
    //iframe.style.top = '0';
    //iframe.style.left = '0';
    iframe.style.width = '100%';
    iframe.style.height = '300px';
    iframe.style.border = '0';
    jQuery(this).html(iframe);
  });
});

/********** Collection Page - Script to scroll to bottom *******************/
jQuery(document).ready(function(){
  jQuery(".gotomoredetail").click(function() {
      jQuery('html, body').animate({
          scrollTop: jQuery(".product__list").offset().top + jQuery(".product__list").innerHeight() - 100
      }, 1000);
  });
});

/*************************** Change Judge.me section heading content *************************/
jQuery(".jdgm-carousel-title-and-link .jdgm-carousel-title").each(function(index, element) {
	var heading = jQuery(element), word_array, last_part, first_word; 
    word_array = heading.html().split(/\s+/);
    first_word = word_array.shift();         
    last_part = word_array.join(' ');        
    heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
});
setTimeout(function(){
    jQuery(".jdgm-carousel-title-and-link .jdgm-carousel-title").each(function(index, element) {
        var heading = jQuery(element), word_array, last_part, first_word; 
        word_array = heading.html().split(/\s+/);
        first_word = word_array.shift();         
        last_part = word_array.join(' ');        
        heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
    });
}, 2000);
setTimeout(function(){
    jQuery(".jdgm-carousel-title-and-link .jdgm-carousel-title").each(function(index, element) {
        var heading = jQuery(element), word_array, last_part, first_word; 
        word_array = heading.html().split(/\s+/);
        first_word = word_array.shift();         
        last_part = word_array.join(' ');        
        heading.html([first_word, '<strong>', last_part, '</strong>'].join(' '));
    });
}, 5000);